import { FormsHelper } from "@/Common/Helpers/MyleFormsHelper";

interface IHasAttributes {
    Attributes: FormAttribute[];
}

interface IHasElementType {
    ElementType: ElementType;
}

class FormComponentBase implements IHasAttributes, IHasElementType {
    public Attributes: FormAttribute[];
    public ElementType: ElementType;

    public constructor(fields?: Partial<FormComponentBase>) {
        Object.assign(this, fields);
    }

    public getComponentName(attributeName: string = null): string {
        return FormsHelper.getComponentName(this, attributeName);
    }
}

class FormComponent extends FormComponentBase {
    public Position: number;
    public FormPath: string;
    public InternalName: string;
    public Value: string;
    public ValidationRules: FormValidationRule[];
}

class FormAttribute {
    public AttributeType: AttributeType;
    public Name: string;
    public Culture: string;
    public Value: string;
    public Index: number;
}

class FormValidationRule {
    public ValidationType: ValidationType;
    public ValidationInfo: string;
}

class FormSection extends FormComponent {
    public SectionType: SectionType;
    public Elements: FormElement[];

    public constructor(fields?: Partial<FormSection>) {
        super(fields);
        this.Elements = fields?.Elements?.map(x => new FormElement(x)) || [];
    }
}

class FormElement extends FormComponent {
    public ElementType: ElementType;
    public InputMask: string;
}

enum ValidationType {
    Unknown = 0,
    NotEmpty,
    LessThan,
    LessOrEqualThan,
    MoreThan,
    MoreOrEqualThan,
    MinLength,
    MaxLength,
    MatchesValidationMask
}

enum AttributeType {
    Unknown = 0,
    Label = 1,
    CheckboxOption,
    Option,
    OtherValue
}

enum ElementType {
    Unknown = 0,
    TextInput = 1,
    NumberInput,
    NumberRangeInput,
    DateInput,
    DateRangeInput,
    CheckboxListInput,
    OptionListInput,
    TextAreaInput,
    YesNoNotApplicableOptionInput,
    ScaleInput,
    InformationLabel,
    YesNoOptionInput
}

enum SectionType {
    Unknown = 0
}

enum TemplateType {
    Unknown = 0
}

export { AttributeType, ElementType, FormAttribute, FormComponent, FormComponentBase, FormElement, FormSection, IHasAttributes, IHasElementType, TemplateType, ValidationType };
